import { useMemo } from 'react';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { DEFAULT_CONFIG, type StepComponent } from '../../common/constants/steps';
import { getStepConfig } from '../../common/utils/import-steps';
import {
	useStep,
	useImportType,
	useProjectData,
	useSource,
	useSelectedSourceItem,
} from '../import-state/selectors';

export const useProductSteps = () => {
	const [step] = useStep();
	const [importType] = useImportType();
	const [{ type }] = useProjectData();
	const { isSiteAdmin, isAdmin } = useTenantContext();
	const [source] = useSource();
	const [selectedSourceItem] = useSelectedSourceItem();

	const productSteps = useMemo(
		() =>
			getStepConfig({
				importType,
				projectType: type,
				isSiteAdmin,
				isAdmin,
				source,
				supportedFlow: selectedSourceItem?.supportedFlow,
			}),
		[importType, isAdmin, isSiteAdmin, selectedSourceItem?.supportedFlow, source, type],
	);

	const currentStepIndex = productSteps.findIndex(
		(productStep: StepComponent) => productStep.step === step,
	);
	return {
		productSteps,
		currentStepIndex,
		currentStepConfig: productSteps[currentStepIndex] ?? DEFAULT_CONFIG,
	};
};

export { usePreventCancelImport } from './use-prevent-cancel-import';
export { useTools, useImportTool } from './use-tools';
